// extracted by mini-css-extract-plugin
module.exports = {"numeric-input":"NumericInput_numeric-input__ke_CH","no-margin":"NumericInput_no-margin__3eMjJ","strike":"NumericInput_strike__aPSo6","input":"NumericInput_input__1YwwM"};